import React, { FunctionComponent, useState } from 'react'

import styled from 'styled-components/native'

import { EligibilityCapsule } from '../../molecules/eligiblityCapsule/EligibilityCapsule'

export type EligibilityGroupCapsuleProps = {
  eligibilityCapsuleDetails: ({
    program: string
    label: string
    coverageDescription: string | undefined
    tooltip?: string
    hasLink: boolean
    link: string | undefined
    testID: string
  } | null)[]
}

const CapsuleRow = styled.View({
  flexDirection: 'row',
  flexWrap: 'wrap',
})

export const EligibilityGroupCapsule: FunctionComponent<EligibilityGroupCapsuleProps> = ({
  eligibilityCapsuleDetails,
}) => {
  // Only one selected at a time
  const [selectedProgram, setSelectedProgram] = useState<string | null>(null)

  const handleCapsuleSelect = (program: string) => {
    setSelectedProgram(program)
  }

  return (
    <CapsuleRow>
      {eligibilityCapsuleDetails.map((details) => {
        if (!details) return null
        return (
          <EligibilityCapsule
            testID={details.testID}
            key={details.program}
            label={details.label}
            hasLink={details.hasLink}
            tooltip={details.tooltip ?? details.coverageDescription}
            programBookingLink={details.link}
            // We pass program + isSelected + onSelectProgram for "controlled" usage:
            program={details.program}
            isSelected={selectedProgram === details.program}
            onSelectProgram={handleCapsuleSelect}
          />
        )
      })}
    </CapsuleRow>
  )
}
